import { StoreAction } from "../types/store"
import { Client } from "../lib/client"
import { CurrentClient } from "../lib/currentClient"
import { User } from "@auth0/auth0-react"
import { ClientConfig } from "../lib/clientConfig";

export type LoginAction = StoreAction & { user: User }
export const LOGIN = "LOGIN"
export const login = (user: User): LoginAction => ({ type: LOGIN, user })

export type LogoutAction = StoreAction
export const LOGOUT = "LOGOUT"
export const logout = (): LogoutAction => ({ type: LOGOUT })

export type SetClientsAction = StoreAction & { clients: Client[] }
export const SET_CLIENTS = "SET_CLIENTS"
export const setClients = (clients: Client[]): SetClientsAction => ({
  type: SET_CLIENTS,
  clients,
})
export type SetCurrentClientAction = StoreAction & {
  currentClient: CurrentClient
}
export const SET_CURRENT_CLIENT = "SET_CURRENT_CLIENT"
export const setCurrentClient = (currentClient: CurrentClient): SetCurrentClientAction => ({
  type: SET_CURRENT_CLIENT,
  currentClient,
})
export type SetClientConfigAction = StoreAction & { clientConfig: ClientConfig }
export const SET_CLIENT_CONFIG = "SET_CLIENT_CONFIG"
export const setClientConfig = (clientConfig: ClientConfig): SetClientConfigAction => ({
  type: SET_CLIENT_CONFIG,
  clientConfig,
})
